export enum HallowCartRule {
  HadPreviousTrial = "had_previous_trial_rule",
}
